import { createElement } from 'src/app/core/helpers/dom';
import { GET_ACTIVE_PLAN } from 'src/app/project/modules/plan/plan.store';
import { GET_GROUPING } from '../../columns/grouping.store';
import { GET_TABLE } from '../../table.ui.store';
import { createColumnCellsElement } from '../body-cells';
import { createSelectElement } from '../body-cells-frozen/create-select-element';
import { generatePointRowClasses } from './generate-point-row-classes';

export function createPointRowElement(_index: number): HTMLElement {
  const table = GET_TABLE();
  const item = table.items[_index];
  const pointIndex = item.index;
  const grouping = GET_GROUPING();

  const pointRowElement: HTMLElement = createElement('div', {
    attrs: {
      class: ((): string[] => generatePointRowClasses(_index))(),
    },
    eventListeners: {
      click: () => {
        const activePlan = GET_ACTIVE_PLAN();

        if (!activePlan.active) {
          table.openPointCallback(table.getPoints()[pointIndex]);
          table.activatePoint(table.getPoints()[pointIndex].sequenceNumber);
        }
      },
      mouseenter: () => {
        if (table.highlightPinCallback && table.getPoints()[pointIndex]) {
          // checking if point exists for rare cases when user moves mouse when table is in process of being reloaded
          table.highlightPinCallback(table.getPoints()[pointIndex].sequenceNumber);
        }
      },
      mouseleave: () => {
        if (table.dehighlightPinCallback) {
          table.dehighlightPinCallback();
        }
      },
    },
    children: [createSelectElement(pointIndex), createColumnCellsElement(pointIndex, true)],
  });

  if (grouping.length) {
    // pointRowElement.style.marginLeft = `${16 * grouping.length}px`;
  }

  return pointRowElement;
}
